import {
  DefaultLinkModel,
  DefaultLinkModelOptions
} from '@projectstorm/react-diagrams-defaults'
import { FlowmapColumnType } from '../../index'

export const linkType = 'advanced-link'

export interface Options extends DefaultLinkModelOptions {
  readonly dashed: boolean | undefined
  readonly columnType: FlowmapColumnType | undefined
}

export class CustomLinkModel extends DefaultLinkModel {
  public dashed: Options['dashed']
  public columnType: Options['columnType']

  public constructor(options: Options) {
    super({
      ...options,
      curvyness: 100,
      type: linkType
    })

    this.dashed = options.dashed
    this.columnType = options.columnType
  }

  public serialize() {
    return {
      ...super.serialize(),
      dashed: this.dashed,
      columnType: this.columnType
    }
  }

  public deserialize(event): void {
    super.deserialize(event)
    this.dashed = event.data.dashed
    this.columnType = event.data.columnType
  }
}
